export default {

    componentOptions: {
        rowsPerPageItems: [25, 50, 100, 250],
    },

    STORE_EMPTY: 0,
    STORE_INITIALIZING: 1,
    STORE_READY: 2,

    EVENT_INFO: 0,
    EVENT_SUCCESS: 1,
    EVENT_WARNING: 2,
    EVENT_ERROR: 3,

    LENGTH_COMMENTS: 1000,
    LENGTH_CONTRACT: 9,
    LENGTH_CONTRACT_DESCRIPTION: 40,
    LENGTH_CONTRACT_OBJECT: 500,
    LENGTH_CONTRACT_WARRANTY: 5,
    LENGTH_CONTRACT_UNIT_VALUE: 10,
    LENGTH_CONTRACT_HIRED_AMOUNT: 10,
    LENGTH_CONTRACT_MEASURE_UNIT: 10,
    LENGTH_CONTRACT_ITEM: 40,
    LENGTH_CONTRACT_ITEM_QUANTITY: 9,
    LENGTH_DEMAND: 6,
    LENGTH_DEMAND_CODE: 10,
    LENGTH_DESCRIPTION: 1000,
    LENGTH_DAYS_TO_DELIVERY: 10,
    LENGTH_EMAIL: 60,
    LENGTH_ESTIMATED_TIME: 10,
    LENGTH_EXECUTED_TIME: 10,
    LENGTH_FILES_DESCRIPTION: 1000,
    LENGTH_REASON: 1000,
    LENGTH_BILLING_REFERENCE: 6,
    LENGTH_OUTCOME: 1000,
    LENGTH_PLANNED_TIME: 10,
    LENGTH_REMARKS: 1000,
    LENGTH_SIMILAR_DEMANDS: 100,
    LENGTH_SYSTEM_ACRONYM: 8,
    LENGTH_SYSTEM_NAME: 100,
    LENGTH_SYSTEM_DESCRIPTION: 300,
    LENGTH_TITLE: 100,
    LENGTH_TYPE_APPROVER_NAME: 50,
    LENGTH_TYPE_DEMAND_NAME: 60,
    LENGTH_TYPE_DEMAND_DESCRIPTION: 500,
    LENGTH_UNIT: 20,

    ROLES_ADMIN: 'ngds/admin',
    ROLES_EDIT_SYSTEM: 'ngds/admin', // 'ngds/sistema_cadastro',
    ROLES_EDIT_CONTRACT: 'ngds/admin', // 'ngds/contrato_cadastro',
    ROLES_EDIT_APPROVER_TYPE: 'ngds/admin', // 'ngds/tipo_aprovador_cadastro',
    ROLES_EDIT_DEMAND_TYPE: 'ngds/admin', // 'ngds/tipo_demanda_cadastro',
    ROLES_EDIT_PERSON: 'ngds/admin', // 'ngds/pessoa_cadastro',

    STATUS_ANY: 0,
    STATUS_CREATED: 1,
    STATUS_CREATED_APPROVAL: 2,
    STATUS_PLANNING: 3,
    STATUS_PLANNING_APPROVAL: 4,
    STATUS_DELIVERY: 5,
    STATUS_DELIVERY_APPROVAL: 6,
    STATUS_FINALIZING: 7,
    STATUS_REJECTED: 8,
    STATUS_DONE: 9,

    EVENT_APPROVED: 1,
    EVENT_REJECTED: 100,
};



// WEBPACK FOOTER //
// ./src/helpers/constants.js